const locale = require('./help.i18n.json');

/*@ngInject*/
const HelpController = function ($uibModal, $window, appTypeConfigurationModel, coreMediator, coreConstant) {

    this.i18n = locale;

    this.isOpen = false;

    this.$onInit = function () {
        const consoleType = appTypeConfigurationModel.getConsoleType();

        switch (consoleType) {
            case coreConstant.authorization.CONSOLE_TYPE_UM:
            case coreConstant.authorization.CONSOLE_TYPE_UM_AGENT:
                this.aboutUmsLabel = this.i18n.helpMenu.aboutUm;
                break;

            case coreConstant.authorization.CONSOLE_TYPE_UM_STUDIO:
                this.aboutUmsLabel = this.i18n.helpMenu.aboutUmStudio;
                break;
        }
    };

    this.onIconClick = function () {
        this.isOpen = !this.isOpen;
    };

    this.showAboutUms = function () {
        coreMediator.getUmVersionNumber().then((versionNumberDetail) => {
            coreMediator.getRevision().then((revisionDetail) => {
                $uibModal.open({
                    templateUrl: '/help/aboutUmsModal/aboutUmsModal.tpl.html',
                    controller: 'aboutUmsModalController',
                    backdrop: 'static',
                    windowClass: 'aboutUmsModal',
                    resolve: {
                        options: () => {
                            return {
                                revNumber: revisionDetail.revNumber,
                                umVersionNumber: versionNumberDetail.customerReleaseName
                            };
                        }
                    }
                });
            });
        });

        this.isOpen = !this.isOpen;
    };

    this.showOnlineHelp = function (topic) {
        let url = `../${this.i18n.url.prefix}/${_.get(this.i18n.url, appTypeConfigurationModel.getUserType())}/${this.i18n.url.index}`;

        if (!_.isEmpty(topic)) {
            url += '#cshid=' + topic;
        }

        $window.open(url, '_blank');
        this.isOpen = !this.isOpen;
    };
};

angular.module('gw-um-header')
    .controller('helpController', HelpController);
